<mat-dialog-content [ngClass]="{'header': tipLabel || tip1Label}">
  <h2 class="text-center">{{ header }}</h2>
</mat-dialog-content>
<p *ngIf="tipLabel" class="text-center">{{tipLabel}}</p>
<p *ngIf="warnLabel" class="text-center warn-message px-4" ><strong>Warning: </strong> {{warnLabel}}</p>
<p *ngIf="warn1Label" class="text-center warn-message px-4" ><strong>Warning: </strong> {{warn1Label}}</p>
<eq-seperator *ngIf="!confirmLabel && tipLabel"></eq-seperator>

<div class="d-flex row justify-content-around m-0">
  <eq-seperator class="h-line" *ngIf="!pendingPaymentRiderEntries"></eq-seperator>
  <div class="col-10 mb-3" *ngIf="!confirmLabel && rejectLabel && acceptLabel">
    <div class="row">
      <div
        class="col text-center"
      >
        <button
          mat-flat-button
          color="primary"
          type="button"
          class="back-btn"
          (click)="reject()"
        >
          <span style="color: #007297">{{rejectLabel}}</span>
        </button>
      </div>
      <div class="col-1" >
        <span class="vl"></span>
      </div>
      <div class="col text-center">
        <button
          mat-flat-button
          color="primary"
          type="button"
          class="next-btn"
          (click)="accept()"
        >
          <span class="submit-btn-label">{{ acceptLabel }}</span>
        </button>
      </div>
    </div>
  </div>
  <div class="col text-center mb-3" *ngIf="confirmLabel">
    <button
    mat-flat-button
    color="primary"
    type="submit"
    class="next-btn"
    (click)="accept()"
    >
    <span>{{confirmLabel}}<mat-icon>arrow_right</mat-icon></span>
  </button>
  </div>
  <hr *ngIf="pendingPaymentRiderEntries && pendingPaymentRiderEntries?.length && tipLabel">
  <section *ngIf="pendingPaymentRiderEntries && pendingPaymentRiderEntries?.length" class="mb-3 mt-3">
    <p *ngIf="tip1Label" class="text-center">{{tip1Label}}</p>
    <div class="entry-fees-section">
      <div *ngFor="let entry of pendingPaymentRiderEntries" class="d-flex mb-2 justify-content-between">
        <p>{{entry.riderName}}</p>
        <button mat-flat-button color="primary" type="submit" class="next-btn" (click)="goToRiderShows(entry.riderId)">
          <span>Pay Show Entry Fees</span>
        </button>
      </div>
    </div>
  </section>
  <div class="col text-center mb-3" *ngIf="maybeLaterLabel && pendingPaymentRiderEntries && pendingPaymentRiderEntries?.length">
    <button
    mat-flat-button
    color="primary"
    type="submit"
    class="next-btn"
    (click)="reject()"
    >
    <span>{{maybeLaterLabel}}</span>
  </button>
  </div>
</div>
